import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.support');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-support',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.support/view.scss */
/* src/app/page.support/view.scss: no such file or directory */`],
})
export class PageSupportComponent implements OnInit, DoCheck {

    public sub: any = '';
    public id: any = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        this.sub = WizRoute.segment.sub;
        this.id = WizRoute.segment.id;
        await this.service.render();
    }

    public async ngDoCheck() {
        this.sub = WizRoute.segment.sub;
        this.id = WizRoute.segment.id;
    }
}

export default PageSupportComponent;